import React from 'react';

export const ChecklistTab = ({ data, setData }) => {
  const updateChecklist = React.useCallback((field, subfield, value) => {
    setData(prev => ({
      ...prev,
      checklist: {
        ...prev.checklist,
        [field]: {
          ...prev.checklist?.[field],
          [subfield]: value
        }
      }
    }));
  }, [setData]);

  const addAutreItem = React.useCallback(() => {
    setData(prev => ({
      ...prev,
      checklist: {
        ...prev.checklist,
        autres: [...(prev.checklist?.autres || []), {
          id: Date.now(),
          item: '',
          statut: '',
          commentaire: ''
        }]
      }
    }));
  }, [setData]);

  const updateAutreItem = React.useCallback((index, field, value) => {
    setData(prev => {
      const updatedAutres = [...(prev.checklist?.autres || [])];
      updatedAutres[index] = {
        ...updatedAutres[index],
        [field]: value
      };
      return {
        ...prev,
        checklist: {
          ...prev.checklist,
          autres: updatedAutres
        }
      };
    });
  }, [setData]);

  const removeAutreItem = React.useCallback((index) => {
    setData(prev => ({
      ...prev,
      checklist: {
        ...prev.checklist,
        autres: (prev.checklist?.autres || []).filter((_, i) => i !== index)
      }
    }));
  }, [setData]);

  const StatutSelect = ({ value, onChange }) => (
    <select 
      value={value || ''} 
      onChange={(e) => onChange(e.target.value)}
      className={`w-full px-3 py-2 rounded border ${
        value === 'OK' ? 'bg-green-100 border-green-300 text-green-800' :
        value === 'En cours' ? 'bg-yellow-100 border-yellow-300 text-yellow-800' :
        value === 'A faire' ? 'bg-red-100 border-red-300 text-red-800' :
        value === 'N/A' ? 'bg-gray-100 border-gray-300 text-gray-800' :
        'bg-white border-gray-300'
      }`}
    >
      <option value="">-- Sélectionner --</option>
      <option value="OK">OK</option>
      <option value="En cours">En cours</option>
      <option value="A faire">A faire</option>
      <option value="N/A">N/A</option>
    </select>
  );

  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Checklist de Déploiement</h2>

      {/* Items de checklist principaux */}
      <div>
        <h3 className="text-lg font-semibold text-blue-700 mb-4 border-b border-blue-200 pb-2">
          Points de contrôle obligatoires
        </h3>
        
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left w-1/3">Item</th>
                <th className="border border-gray-300 px-4 py-2 text-left w-1/6">Statut</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Commentaire</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-3 font-medium">
                  Mise en place des sondes
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  <StatutSelect 
                    value={data.miseEnPlaceSondes?.statut}
                    onChange={(value) => updateChecklist('miseEnPlaceSondes', 'statut', value)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  <input
                    type="text"
                    value={data.miseEnPlaceSondes?.commentaire || ''}
                    onChange={(e) => updateChecklist('miseEnPlaceSondes', 'commentaire', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Détails, date, responsable..."
                  />
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-3 font-medium">
                  Partage du process de ticketing support Jira
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  <StatutSelect 
                    value={data.partageProcessTicketing?.statut}
                    onChange={(value) => updateChecklist('partageProcessTicketing', 'statut', value)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  <input
                    type="text"
                    value={data.partageProcessTicketing?.commentaire || ''}
                    onChange={(e) => updateChecklist('partageProcessTicketing', 'commentaire', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Détails, date, responsable..."
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-3 font-medium">
                  Vérifier que toutes les informations nécessaires sont dans Bitwarden
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  <StatutSelect 
                    value={data.informationsBitwarden?.statut}
                    onChange={(value) => updateChecklist('informationsBitwarden', 'statut', value)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  <input
                    type="text"
                    value={data.informationsBitwarden?.commentaire || ''}
                    onChange={(e) => updateChecklist('informationsBitwarden', 'commentaire', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Détails, date, responsable..."
                  />
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-3 font-medium">
                  Environnement QUAL
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  <StatutSelect 
                    value={data.environnementQual?.statut}
                    onChange={(value) => updateChecklist('environnementQual', 'statut', value)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  <input
                    type="text"
                    value={data.environnementQual?.commentaire || ''}
                    onChange={(e) => updateChecklist('environnementQual', 'commentaire', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Détails, date, responsable..."
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Autres items de checklist */}
      <div>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-green-700">Autres points de contrôle</h3>
          <button
            onClick={addAutreItem}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
          >
            + Ajouter un item
          </button>
        </div>

        {data.autres && data.autres.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left w-1/3">Item</th>
                  <th className="border border-gray-300 px-4 py-2 text-left w-1/6">Statut</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Commentaire</th>
                  <th className="border border-gray-300 px-4 py-2 text-center w-16">Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.autres.map((item, index) => (
                  <tr key={item.id || index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        type="text"
                        value={item.item || ''}
                        onChange={(e) => updateAutreItem(index, 'item', e.target.value)}
                        className="w-full px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Description de l'item"
                      />
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <StatutSelect 
                        value={item.statut}
                        onChange={(value) => updateAutreItem(index, 'statut', value)}
                      />
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        type="text"
                        value={item.commentaire || ''}
                        onChange={(e) => updateAutreItem(index, 'commentaire', e.target.value)}
                        className="w-full px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Commentaire"
                      />
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <button
                        onClick={() => removeAutreItem(index)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
            <p className="text-gray-500 mb-4">Aucun autre point de contrôle ajouté</p>
          </div>
        )}
      </div>

      {/* Liste de suggestions */}
      <div className="mt-8 bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h4 className="font-semibold text-gray-800 mb-3">Points de contrôle suggérés :</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-gray-600">
          <div>• Formation des utilisateurs effectuée</div>
          <div>• Documentation utilisateur livrée</div>
          <div>• Tests d'intégration validés</div>
          <div>• Sauvegarde configurée et testée</div>
          <div>• Plan de reprise d'activité défini</div>
          <div>• Certificats SSL installés</div>
          <div>• Monitoring opérationnel</div>
          <div>• Contrats de support signés</div>
          <div>• Accès VPN configurés</div>
          <div>• Procédure d'escalade communiquée</div>
        </div>
      </div>

      {/* Récapitulatif des statuts */}
      <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
        <h4 className="font-semibold text-blue-800 mb-2">Récapitulatif</h4>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          <div className="text-center">
            <div className="font-medium text-green-700">OK</div>
            <div className="text-2xl font-bold text-green-700">
              {[
                data.miseEnPlaceSondes?.statut,
                data.partageProcessTicketing?.statut,
                data.informationsBitwarden?.statut,
                data.environnementQual?.statut,
                ...(data.autres?.map(i => i.statut) || [])
              ].filter(s => s === 'OK').length}
            </div>
          </div>
          <div className="text-center">
            <div className="font-medium text-yellow-700">En cours</div>
            <div className="text-2xl font-bold text-yellow-700">
              {[
                data.miseEnPlaceSondes?.statut,
                data.partageProcessTicketing?.statut,
                data.informationsBitwarden?.statut,
                data.environnementQual?.statut,
                ...(data.autres?.map(i => i.statut) || [])
              ].filter(s => s === 'En cours').length}
            </div>
          </div>
          <div className="text-center">
            <div className="font-medium text-red-700">À faire</div>
            <div className="text-2xl font-bold text-red-700">
              {[
                data.miseEnPlaceSondes?.statut,
                data.partageProcessTicketing?.statut,
                data.informationsBitwarden?.statut,
                data.environnementQual?.statut,
                ...(data.autres?.map(i => i.statut) || [])
              ].filter(s => s === 'A faire').length}
            </div>
          </div>
          <div className="text-center">
            <div className="font-medium text-gray-700">N/A</div>
            <div className="text-2xl font-bold text-gray-700">
              {[
                data.miseEnPlaceSondes?.statut,
                data.partageProcessTicketing?.statut,
                data.informationsBitwarden?.statut,
                data.environnementQual?.statut,
                ...(data.autres?.map(i => i.statut) || [])
              ].filter(s => s === 'N/A').length}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};